export function isNicheKink(item) {
  return item?.tier === 'niche' || item?.populationStatus === 'archived';
}

export function filterVisibleKinks(items = []) {
  return items.filter((item) => !isNicheKink(item));
}
